<template>
  <!-- ======= Footer ======= -->
  <footer id="footer" class="footer footer-dark">
    <div class="footer-top">
      <div class="container">
        <div class="has-text-centered mb-6">
          <router-link to="/">
            <img
              src="../assets/logo_takima_horizontal_inverted-1.png"
              width="20%"
            />
          </router-link>
        </div>

        <div class="columns">
          <div class="column is-half footer-links pl-5 pr-5">
            <h4>
              <router-link to="/licenses" v-html="$t('license')"></router-link>
            </h4>
            <p class="mb-6" style="text-align: justify">
              <span v-html="$t('layMainFooter.license-txt')" />
            </p>
            <h4 v-html="$t('layMainFooter.link')"></h4>
            <div class="columns">
              <!-- <div class="column has-text-centered">
                <p class="heading">Labos 1point5</p>
                <p class="title">
                  <a target="_blank" href="https://labos1point5.org">
                    <img
                      src="../assets/LogoRond_BlancPourEcran.png"
                      style="
                        max-width: 40px;
                        border-radius: 50%;
                        background-color: rgba(52, 59, 64, 1);
                      "
                    />
                  </a>
                </p>
              </div> -->
              <div class="column has-text-centered">
                <p class="heading">Framagit</p>
                <p class="title">
                  <a target="_blank" href="https://framagit.org/labos1point5/">
                    <span class="icon">
                      <i class="fa fa-gitlab" style="font-size: 32px"></i>
                    </span>
                  </a>
                </p>
              </div>
              <div class="column has-text-centered">
                <p class="heading">Peertube</p>
                <p class="title">
                  <a target="_blank" href="https://peer.tube/a/labos1point5">
                    <span class="icon">
                      <i class="fa fa-peertube" style="font-size: 32px"></i>
                    </span>
                  </a>
                </p>
              </div>
              <div class="column has-text-centered">
                <p class="heading">Mastodon</p>
                <p class="title">
                  <a target="_blank" href="https://botsin.space/@labos1point5">
                    <span class="icon">
                      <i class="fa fa-mastodon" style="font-size: 32px"></i>
                    </span>
                  </a>
                </p>
              </div>
              <div class="column has-text-centered">
                <p class="heading">Framasoft</p>
                <p class="title mb-40">
                  <a
                    class="framasoft logo"
                    target="_blank"
                    href="https://framasoft.org/fr/"
                  ></a>
                </p>
              </div>
            </div>
          </div>
          <div class="column footer-links pl-5 pr-5">
            <h4>
              <router-link
                to="/approach"
                v-html="$t('layMainFooter.approach')"
              ></router-link>
            </h4>
            <p class="mb-6" style="text-align: justify">
              <span v-html="$t('layMainFooter.approach-txt')" />
            </p>
          </div>
          <div class="column footer-contact pl-5 pr-5">
            <h4>Notes</h4>
            <p class="mb-4" style="text-align: justify">
              <span v-html="$t('layMainFooter.ekocentral-description')" />
            </p>
            <p class="mb-3" style="text-align: justify">
              <span
                v-html="$t('layMainFooter.' + footerNotes.i18n)"
                v-if="footerNotes.i18n"
              />
            </p>
            <div class="has-text-centered mb-5">
              <a
                v-for="(img, index) in footerNotes.imgs"
                class="pr-5"
                target="blank"
                href="img.href"
                :key="index"
              >
                <img :src="img.src" style="max-height: 40px" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="copyright">
        <small>
          <span v-html="$t('layMainFooter.host-and-conception')" />
          <br />
        </small>
      </div>
    </div>
  </footer>
  <!-- End Footer -->
</template>

<script>
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'MainFooter',
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    footerNotes () {
      const notes = this.coreStore.conf.FOOTER_NOTES
      return notes ? notes.value : {}
    }
  }
}
</script>
